import { render, staticRenderFns } from "./showIdeaProjectsStandPreview.vue?vue&type=template&id=58e52505&scoped=true"
import script from "./showIdeaProjectsStandPreview.vue?vue&type=script&lang=js"
export * from "./showIdeaProjectsStandPreview.vue?vue&type=script&lang=js"
import style0 from "./showIdeaProjectsStandPreview.vue?vue&type=style&index=0&id=58e52505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e52505",
  null
  
)

export default component.exports